import {environment} from "../../environments/environment";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ContactUsResponse} from "../models/contactUs .model";

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient,) {

  }

  saveContactUs(contactUsResponse: ContactUsResponse): Observable<ContactUsResponse> {
    return this.http.post<ContactUsResponse>(`${this.apiUrl}/contact-us`, contactUsResponse);
  }

}
